import React from 'react';
import { createPortal } from 'react-dom';

import {
  museoSans100italic,
  museoSans100normal,
  museoSans300italic,
  museoSans300normal,
  museoSans500italic,
  museoSans500normal,
  museoSans700italic,
  museoSans700normal,
  museoSans900italic,
  museoSans900normal
} from './fonts';

const fontsAsArr = [
  museoSans100italic,
  museoSans100normal,
  museoSans300italic,
  museoSans300normal,
  museoSans500italic,
  museoSans500normal,
  museoSans700italic,
  museoSans700normal,
  museoSans900italic,
  museoSans900normal
];

const FontStyle = () => {
  return (
    <style type="text/css">
      {fontsAsArr.map(
        font => `
        @font-face {
            font-family: ${font.fontFamily};
            src: ${font.src};
            font-weight: ${font.fontWeight};
            font-style: ${font.fontStyle};
        }
      `
      )}
    </style>
  );
};

const FontsLoader = () => {
  /** We must declare font-face at a global level (body)
   * because other wise it won't work inside a shadow-dom
   * */
  return createPortal(<FontStyle />, document.body);
};

export default FontsLoader;
